import { render, staticRenderFns } from "./AdminNewReservation.vue?vue&type=template&id=1a0d7ddf&scoped=true&"
import script from "./AdminNewReservation.vue?vue&type=script&lang=js&"
export * from "./AdminNewReservation.vue?vue&type=script&lang=js&"
import style0 from "./AdminNewReservation.vue?vue&type=style&index=0&id=1a0d7ddf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0d7ddf",
  null
  
)

export default component.exports